
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13 3.55a3.74 3.74 0 00-3.64 2.88H2.93a.3.3 0 00-.3.3v1.15a.3.3 0 00.3.3h6.437A3.74 3.74 0 1013 3.55zm0 1.75a2 2 0 110 4 2 2 0 010-4z","fill":"#3D6BE3"}}),_c('path',{attrs:{"d":"M18.89 6.43h2.22a.3.3 0 01.3.3v1.15a.3.3 0 01-.3.3h-2.22a.3.3 0 01-.3-.3V6.73a.3.3 0 01.3-.3zM21.1 15.82h-6.91a.3.3 0 00-.3.3v1.15a.3.3 0 00.3.3h6.91a.3.3 0 00.3-.3v-1.15a.3.3 0 00-.3-.3z","fill":"#3D6BE3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.625 17.57A3.74 3.74 0 0012 16.69 3.75 3.75 0 008.26 13v-.05a3.74 3.74 0 00-3.637 2.87H2.93a.3.3 0 00-.3.3v1.15a.3.3 0 00.3.3h1.695zm4.746-2.533a2 2 0 10-2.222 3.325 2 2 0 002.222-3.325z","fill":"#3D6BE3"}})])
          )
        }
      }
    